const functionCallbacks = {
  open_document: function(data){
    document.location.href = data.result.url
  }
}

export default functionCallbacks
